"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ViewportProvider = _interopRequireDefault(require("../Viewport/ViewportProvider"));

var _cobalt_design = require("@cobalt/cobalt_design");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Root =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Root, _React$Component);

  function Root(props) {
    var _this;

    _classCallCheck(this, Root);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Root).call(this, props));
    _this.state = {
      status: 'loading'
    };
    _this.onLoadSucceeded = _this.onLoadSucceeded.bind(_assertThisInitialized(_this));
    _this.onLoadFailed = _this.onLoadFailed.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Root, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadBundle(this.props.themeURL, this.props.fontURL, this.props.stylesheetURL).then(this.onLoadSucceeded, this.onLoadFailed);
    }
  }, {
    key: "onLoadSucceeded",
    value: function onLoadSucceeded() {
      this.setState({
        status: 'success'
      }, this.props.onSuccess);
    }
  }, {
    key: "onLoadFailed",
    value: function onLoadFailed(e) {
      console.error('Error Loading Cobalt', e);
      this.setState({
        status: 'error'
      }, this.props.onError);
    }
  }, {
    key: "render",
    value: function render() {
      var status = this.state.status;
      var _this$props = this.props,
          children = _this$props.children,
          loaderPlaceholder = _this$props.loaderPlaceholder,
          errorPlaceholder = _this$props.errorPlaceholder,
          style = _this$props.style;

      if (status === 'loading') {
        return loaderPlaceholder;
      } else if (status === 'error') {
        return errorPlaceholder;
      } else {
        return _react.default.createElement(_ViewportProvider.default, null, _react.default.createElement("div", {
          className: "".concat(_cobalt_design.COBALT_SELECTOR, " ").concat(_cobalt_design.COBALT_COMPATIBILITY_MODIFIER),
          style: style
        }, children));
      }
    }
  }]);

  return Root;
}(_react.default.Component);

Root.propTypes = {
  children: _propTypes.any.isRequired,
  loaderPlaceholder: _propTypes.any,
  errorPlaceholder: _propTypes.any,
  onSuccess: _propTypes.func,
  onError: _propTypes.func,
  loadBundle: _propTypes.func,

  /** Valid URL pointing to a @@.css@@ file */
  themeURL: _propTypes.string,

  /** Valid URL pointing to a file with font-family */
  fontURL: _propTypes.string,

  /** Valid URL pointing to a @@.css@@ file */
  stylesheetURL: _propTypes.string
};

var noop = function noop() {};

Root.defaultProps = {
  loaderPlaceholder: null,
  errorPlaceholder: null,
  onSuccess: noop,
  onError: noop,
  loadBundle: _cobalt_design.loadBundle
};
Root.loadBundle = _cobalt_design.loadBundle;
var _default = Root;
exports.default = _default;
Root.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onLoadSucceeded",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onLoadFailed",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Root",
  "props": {
    "loaderPlaceholder": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "errorPlaceholder": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "onSuccess": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onError": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "loadBundle": {
      "defaultValue": {
        "value": "loadBundle",
        "computed": true
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "themeURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Valid URL pointing to a @@.css@@ file"
    },
    "fontURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Valid URL pointing to a file with font-family"
    },
    "stylesheetURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Valid URL pointing to a @@.css@@ file"
    }
  }
};